module.exports = __webpack_public_path__ + "img/548109108916650_thumbnail.jpg";